import { render } from "./person-certificate.vue?vue&type=template&id=a2ac6d22&scoped=true"
import script from "./person-certificate.vue?vue&type=script&lang=js"
export * from "./person-certificate.vue?vue&type=script&lang=js"

import "./person-certificate.vue?vue&type=style&index=0&id=a2ac6d22&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2ac6d22"]])

export default __exports__